// extracted by mini-css-extract-plugin
export default {"container":"WK-z","topReviewHeading":"XK-z","criticalReview":"YK-z","favorableReview":"ZK-z","vsSeparator":"_K-z"};